module.exports = __webpack_public_path__ + "static/img/a.d69d19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a.png
// module id = 43rK
// module chunks = 0